/*
 * trpc (client)
 */
import { supabase } from "@psychology/auth/client"
import type { AppRouter } from "@psychology/trpc/client"
import { httpBatchLink } from "@trpc/client"
import { createTRPCReact } from "@trpc/react-query"
import superjson from "superjson"

export const trpc = createTRPCReact<AppRouter>()

function getApiOrigin() {
	let domain: string = import.meta.env.VITE_API_DOMAIN
	if (domain) {
		return domain
	}

	domain = window.location.origin
	if (!domain.includes("https")) {
		domain = `${domain.split(/:\d\d*/)[0]}:${import.meta.env.VITE_API_PORT || 4000}`
	}
	console.log("[DEBUG] API domain:", domain)
	return domain
}

async function getAuthToken(): Promise<string | null> {
	const {
		data: { session },
	} = await supabase.auth.getSession()
	return session?.access_token || null
}

export const trpcClient = trpc.createClient({
	links: [
		httpBatchLink({
			url: `${getApiOrigin()}/api/v1/trpc`,
			transformer: superjson,
			methodOverride: "POST",
			async headers() {
				const token = await getAuthToken()
				return {
					authorization: token ? `Bearer ${token}` : "",
				}
			},
			maxURLLength: 2083,
		}),
	],
})
